import React, { useContext, useState, useLayoutEffect } from "react"
import styled from "styled-components"

import { ScrollerContext } from "../elements/SmoothScroll/context"

import Landing from "./Landing"
import January from "./January"
import February from "./February"
import March from "./March"
import April from "./April"
import May from "./May"
import June from "./June"
import July from "./July"
import August from "./August"
import September from "./September"
import October from "./October"
import November from "./November"
import December from "./December"

import Footer from "../Footer"

const Preload = styled.div`
  max-height: ${props => (props.active ? `auto` : `100vh`)};
`

const HomePage = () => {
  const [active, setActive] = useState(false)
  const context = useContext(ScrollerContext)

  useLayoutEffect(() => {
    setActive(true)
  }, [context.isActive])

  return (
    <>
      <Preload active={active}>
        <Landing />
        <January />
        <February />
        <March />
        <April />
        <May />
        <June />
        <July />
        <August />
        <September />
        <October />
        <November />
        <December />
        <Footer />
      </Preload>
    </>
  )
}

export default HomePage
